import React, { useState } from "react";

import styled, {css} from "styled-components";
import DateTimeRangePicker from "components/DateRangePicker/DateTimerRangePicker";
import CustomSelfClearedForm from "components/client/Form/CustomSelfClearedForm";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";
import { debounce } from "utils";
import CustomField from "components/Form/CustomField";
import { BaseCheckboxField } from "components/base/BaseForm";
import m from "definedMessages";

import { CheckboxGroup, Input, Schema, SelectPicker } from "rsuite";

const {StringType} = Schema.Types;

const MAX_CHARACTERS = 40;


const TrafficFilter = ({
    isCdr,
    filter,
    disabled,
    issueWidth,
    isSmallMobile,
    defaultFilter,
    subAccountList,

    formatMessage,
    onChangeFilter
}) => {

    const [dateFilterOpened, setDateTimeOpened] = useState(false);

    const filtersModel = Schema.Model({
        filter_cli: StringType()
            .pattern(/^\d+$/, formatMessage(m.correctNumber))
            .maxLength(MAX_CHARACTERS, formatMessage(m.maxLength, {count: MAX_CHARACTERS})),
        filter_phone: StringType()
            .pattern(/^\d+$/, formatMessage(m.correctNumber))
            .maxLength(MAX_CHARACTERS, formatMessage(m.maxLength, {count: MAX_CHARACTERS}))
    });

    const handleChangeDateTime = (value) => {
        const filterValue = {
            ...filter,
            range: [value.range[0], value.range[1]]
        }

        onChangeFilter(filterValue);
    };

    return <StyledForm
        clearOn={isCdr}
        model={filtersModel}
        onChange={debounce((value) => {
            const filterValue = {
                ...filter,
                ...value,

                range: filter?.range
            };

            onChangeFilter(filterValue);
        }, 500)}
        formDefaultValue={defaultFilter}
        fluid
        readOnly={disabled}
    >
        <StyledFiltersGrid align="middle">
            <DateFilterItem
                issueWidth={issueWidth}
                isSmallMobile={isSmallMobile}
                dateOpen={dateFilterOpened}
            >
                <DateTimeRangePicker
                    onChange={debounce((value) => {
                        handleChangeDateTime(value);
                    }, 500)}
                    defaultStartDate={defaultFilter?.range[0]}
                    defaultEndDate={defaultFilter?.range[1]}
                    startDate={filter.range[0]}
                    endDate={filter.range[1]}
                    width={270}
                    onOpen={() => {
                        setDateTimeOpened(true);
                    }}
                    onClose={() => {
                        setDateTimeOpened(false);
                    }}
                    // input={false}
                />
            </DateFilterItem>

            <FilterItem issueWidth={issueWidth} width="150px">
                <CustomField
                    accepter={Input}
                    name="filter_cli"
                    placeholder={formatMessage(m.aNumber)}
                    width={150}
                />
            </FilterItem>

            <FilterItem issueWidth={issueWidth} width="150px">
                <CustomField
                    accepter={Input}
                    name="filter_phone"
                    placeholder={formatMessage(m.bNumber)}
                    width={150}
                />
            </FilterItem>

            <FilterItem issueWidth={issueWidth} width="224px">
                <CustomField
                    disabled={disabled}
                    placeholder={formatMessage(m.subaccounts)}
                    accepter={SelectPicker}
                    data={subAccountList}
                    valueKey="id"
                    labelKey="name"
                    name="subacc_id"
                    errorPlacement="topRight"
                />
            </FilterItem>

            {!isCdr && <FilterItem issueWidth={issueWidth} grow={1}>
                <CdrReportGroup
                    filter={filter}
                    disabled={disabled}
                    defaultFilter={defaultFilter}
                    formatMessage={formatMessage}
                    onChangeFilter={onChangeFilter}
                />
            </FilterItem>}
        </StyledFiltersGrid>
    </StyledForm>
};

export default TrafficFilter;


const CdrReportGroup = ({
    filter,
    disabled,
    defaultFilter,
    formatMessage,
    onChangeFilter
}) => {

    const [groupState, setGroupState] = useState(defaultFilter?.group_list);

    const groupItemList = [
        ["subacc", m.subaccount],
        ["cli", m.aNumber],
        ["phone", m.bNumber],
        ["name", m.ranges]
    ];

    const handleChangeGroupList = (value) => {
        const filterValue = {
            ...filter,
            group_list: value
        };

        onChangeFilter(filterValue);
    };

    return <CustomField
        name="group_list"
        accepter={InlineCheckboxGroup}
        defaultValue={defaultFilter?.group_list}
        value={groupState}
        onChange={(value) => {
            setGroupState(value);
            handleChangeGroupList(value);
        }}
    >
        {groupItemList.map((item) => {
            const message = (typeof item[1]) === "string" ? item[1] : formatMessage(item[1]);

            return (<BaseCheckboxField
                key={item[0]}
                value={item[0]}
                defaultChecked
                disabled={disabled}
            >
                {message}
            </BaseCheckboxField>)
        })}
    </CustomField>
};

const StyledForm = styled(CustomSelfClearedForm)`
    && {
        /* margin-top: 20px; */

    }
`;


const StyledFiltersGrid = styled(FlexGrid)`
    && {
        align-items: center;
        gap: 20px;
        margin: 0;
        width: 100%;
    }

    && > .rs-flex-box-grid-item {
        padding: 0;
    }
`;

const FilterItem = styled(FlexGridItem)`
    && {
        width: ${props => props.issueWidth ? "100%" : (props.width || "auto")};

        ${props => props.issueWidth && css`
            .rs-input,
            .rs-picker {
                width: 100% !important;
            }
        `}
    }
`;

const DateFilterItem = styled(FilterItem)`
    && {
        position: inherit;

        .outsideContainer {
            margin-right: 0;
            width: ${props => props.issueWidth ? "100%" : "270px"};
        }

        .outsideContainer > .rs-input {
            width: 100% !important;
        }

        .dateTimeRangePickerContainer {
            width: ${props => props.issueWidth
        ? (props.isSmallMobile ? "100vw" : "500px")
        : "100%"};
        }

        .rdtPicker {
            display: ${props => props.dateOpen
        ? (props.issueWidth ? "inline-block" : "block")
        : "none"};
            position: ${props => props.issueWidth ? "relative" : "absolute"};
        }
    }
`;

const InlineCheckboxGroup = styled(CheckboxGroup).attrs(() => ({
    inline: true
}))`
    && {
        align-items: center;
        flex-direction: row;
        flex-wrap: wrap;
    }
`;
